var map = {
	"./andaman.avif": 592,
	"./background.jpg": 732,
	"./bali.avif": 374,
	"./default.avif": 885,
	"./destinations.avif": 157,
	"./dubai.avif": 917,
	"./featured.avif": 186,
	"./himachal.avif": 943,
	"./kashmir.avif": 345,
	"./kerala-banner-image.avif": 991,
	"./kerala.avif": 814,
	"./logo.png": 153,
	"./maldives.avif": 737,
	"./north-east.avif": 215,
	"./periyar-elephant.avif": 932,
	"./sahil-holidays-logo.png": 707,
	"./search-icon.png": 520,
	"./singapore.avif": 550,
	"./srilanka.avif": 375,
	"./super-deals.avif": 585,
	"./thailand.webp": 305,
	"./vietnam.avif": 360
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 290;